import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ user, onLogout, active, newTasksCount = 0 }) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Mobile Menu Button - Hidden when menu is open */}
      {!isOpen && (
        <button className="mobile-menu-btn" onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}

      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        {/* Close button inside sidebar for mobile */}
        <button className="mobile-close-btn" onClick={toggleSidebar}>
          ✕
        </button>

        <div className="sidebar-header">
          <div className="logo-container">
            <img src="/logo.jpg" alt="LabTrack Logo" className="sidebar-logo" />
            <div className="brand-info">
              <h2>LabTrack</h2>
              <span className="brand-tagline">Research Management</span>
            </div>
          </div>
          
          <div className="user-info">
            <div className="user-avatar">
              {(user.full_name || user.username).charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <p className="user-name">{user.full_name || user.username}</p>
              {user.laboratory?.name && <p className="user-institution">{user.laboratory.name}</p>}
              {user.role === 'superadmin' && (
                <span className="admin-badge" style={{ backgroundColor: '#ff9800' }}>SUPERADMIN</span>
              )}
              {user.role === 'director' && (
                <span className="admin-badge" style={{ backgroundColor: '#2196F3' }}>DIRECTOR</span>
              )}
              {user.role === 'member' && (
                <span className="admin-badge" style={{ backgroundColor: '#4CAF50' }}>MEMBER</span>
              )}
            </div>
          </div>
        </div>
        
        <nav className="sidebar-nav">
          <ul>
            {user.role === 'superadmin' ? (
              <>
                <li>
                  <Link to="/laboratories" className={isActive('/laboratories')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Laboratories</span>
                  </Link>
                </li>
                <li>
                  <Link to="/users" className={isActive('/users')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Users</span>
                  </Link>
                </li>
              </>
            ) : user.role === 'director' ? (
              <>
                <li>
                  <Link to="/users" className={isActive('/users')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Users</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard" className={isActive('/dashboard')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to="/publications" className={isActive('/publications')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Publications</span>
                  </Link>
                </li>
                <li>
                  <Link to="/scholarships" className={isActive('/scholarships')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Scholarships</span>
                  </Link>
                </li>
                <li>
                  <Link to="/congresses" className={isActive('/congresses')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Congresses</span>
                  </Link>
                </li>
                <li>
                  <Link to="/tasks" className={isActive('/tasks')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">
                      Tasks
                      {newTasksCount > 0 && <span className="notification-badge">{newTasksCount}</span>}
                    </span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/dashboard" className={isActive('/dashboard')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Dashboard</span>
                  </Link>
                </li>
                <li>
                  <Link to="/publications" className={isActive('/publications')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Publications</span>
                  </Link>
                </li>
                <li>
                  <Link to="/scholarships" className={isActive('/scholarships')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Scholarships</span>
                  </Link>
                </li>
                <li>
                  <Link to="/congresses" className={isActive('/congresses')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">Congresses</span>
                  </Link>
                </li>
                <li>
                  <Link to="/tasks" className={isActive('/tasks')} onClick={() => setIsOpen(false)}>
                    <span className="nav-text">
                      Tasks
                      {newTasksCount > 0 && <span className="notification-badge">{newTasksCount}</span>}
                    </span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
        
        <div className="sidebar-footer">
          <button className="btn-logout" onClick={onLogout}>
            <span className="nav-text">Logout</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
